import { createRoot } from "react-dom/client";
import { AppProviders } from "@/providers/AppProviders";
import { lazy } from "react";
import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/400-italic.css";
import "@fontsource/inter/700-italic.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/400-italic.css";
import "@fontsource/montserrat/700-italic.css";
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/400-italic.css";
import "@fontsource/playfair-display/700-italic.css";
import "@fontsource/roboto-mono/400.css";
import "@fontsource/roboto-mono/700.css";
import "@fontsource/roboto-mono/400-italic.css";
import "@fontsource/roboto-mono/700-italic.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/400-italic.css";
import "@fontsource/poppins/600-italic.css";
import "@fontsource/lora/400.css";
import "@fontsource/lora/700.css";
import "@fontsource/lora/400-italic.css";
import "@fontsource/lora/700-italic.css";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/700.css";
import "@fontsource/raleway/400-italic.css";
import "@fontsource/raleway/700-italic.css";
import "@fontsource/league-script/400.css";
import "@fontsource/lobster/400.css";
import "@fontsource/rouge-script/400.css";
import "./sass/global.scss";
const App = lazy(() => import("@/components/App"));

const rootBtn = document.getElementById("creator-root")!;
const root = createRoot(rootBtn);

root.render(
  <AppProviders>
    <App />
  </AppProviders>
);
